import crews from "csi/access/crews";
import { REVISION_DRAFT } from "csi/reflection/reflectionConstants";
import { routerStore } from "csi/state/rootStore";
import ToolbarPluginButton from "csi/view/ToolbarPluginButton";
import declare from "dojo/_base/declare";

const UpdateFoodBOMLabelPlugin = declare(ToolbarPluginButton, {
	/**
	 * @override
	 * FoodBOM's "BOMLabelActions" action to be available to user with Food Label Data Sheet Editor roles
	 */
	validatePlugin(ctx) {
		return crews.isInRoles(["Product Specification Administrator", "Product Specification Editor", "TDS - Food Label Editor", "TDS - Food Label Creator", "TDS - Food Label Administrator"], ctx.getContextNode());
	},

	/**
	 * @override
	 * On FoodBOM view, disable the "BOMLabelActions" button if FoodBOMRevision in view is not DRAFT
	 */
	enablePlugin(ctx) {
		const revisionNode = routerStore.locationRevisionNode;
		if (revisionNode?.$Type === "FoodBOMRevision") {
			this._setDisabled(this, revisionNode.State != REVISION_DRAFT);
		}
	},
});

export = UpdateFoodBOMLabelPlugin;